import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // {id, name, quantity}
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { product_id, name, quantity,category,image,price,priceFor } = action.payload;
      const existingItem = state.items.find((item) => item.product_id === product_id);
      if (existingItem) {
        existingItem.quantity += quantity; // increase if already exists
      } else {
        state.items.push({ product_id, name, quantity ,category,image,price,priceFor});
      }
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter((item) => item.product_id !== action.payload);
    },
    updateQuantity: (state, action) => {
      const { product_id, quantity } = action.payload;
      const existingItem = state.items.find((item) => item.product_id === product_id);
      if (existingItem) {
        existingItem.quantity = quantity;
      }
    },
    clearCart: (state) => {
      state.items = [];
    },
     setCart: (state, action) => {
      state.items = action.payload;  // ? Add this to load cart from backend
    }
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart,setCart  } =
  cartSlice.actions;
export default cartSlice.reducer;
